import { Outlet } from "react-router";

import { courseRoutes } from "./course/routes";
import { masterFormRoutes } from "./masterForm/routes";
import { protocolRoutes } from "./protocol/routes";
import { researchTypeRoutes } from "./researchType/routes";
import SettingsListRoute from "./routes/SettingsListRoute";
import { speciesRoutes } from "./species/routes";

export const settingsRoutes = [
    {
        path: "settings",
        handle: { breadcrumb: "settings:settingsListRoute.title" },
        element: <Outlet />,
        children: [
            { index: true, element: <SettingsListRoute /> },
            ...speciesRoutes,
            ...researchTypeRoutes,
            ...courseRoutes,
            ...masterFormRoutes,
            ...protocolRoutes,
        ],
    },
];
